// common
import { ElNotification } from "element-plus";
import "element-plus/theme-chalk/el-notification.css";
import i18n from "@/lang";

// Simplified type alias to avoid TS2589 (excessively deep type instantiation)
// caused by vue-i18n v11's complex overloaded generics on t()
const t: (key: string, ...args: unknown[]) => string = (i18n.global as any).t;

/**
 * This service allows you to get different notification messages
 *
 * @class
 */
class NotificationService {
  /**
   * Show common validation warning notification "Some fields are missing or incorrect filled."
   *
   * @return {void}
   */
  static showCommonWarningValidation(): void {
    ElNotification({
      title: t("common.warning"),
      message: "Some fields are missing or incorrect filled",
      type: "warning",
    });
  }

  /**
   * Show auth error notification "The email address or password you entered is incorrect"
   *
   * @return {void}
   */
  static showAuthError(): void {
    ElNotification({
      title: t("common.warning"),
      message: "The email address or password you entered is incorrect",
      type: "warning",
    });
  }

  /**
   * Show a general error notification "An error occured at our end, please try again"
   *
   * Not sure about it though
   *
   * @return {void}
   */
  static showGeneralResponseError(): void {
    ElNotification({
      title: t("common.warning"),
      message: t("error.general-error"),
      type: "warning",
    });
  }

  /**
   * Show pos config error notification "You don't have access to configuration XXX"
   *
   * @return {void}
   */
  static showPosConfigurationError(name: string): void {
    ElNotification({
      title: t("common.warning"),
      message: `You don't have access to configuration <b>${name}</b>`,
      type: "warning",
      dangerouslyUseHTMLString: true,
    });
  }

  static showCustomError(message: string): void {
    ElNotification({
      title: t("common.warning"),
      message: `${message}`,
      type: "error",
      // dangerouslyUseHTMLString: true,
    });
  }

  static showCustomSuccess(message: string): void {
    ElNotification({
      title: t("common.success"),
      message: `${message}`,
      type: "success",
    });
  }

  static showCustomMessage(
    message: string,
    type: "error" | "success" | "warning"
  ): void {
    ElNotification({
      title: t("common.warning"),
      message: `${message}`,
      type: type,
    });
  }

  static showCustomMessageWithTitle(
    message: string,
    title: string,
    type: "error" | "success" | "warning"
  ): void {
    ElNotification({
      title: title,
      message: `${message}`,
      type: type,
    });
  }

  static showCustomInfoWithTitle(message: string, title: string): void {
    ElNotification({
      title: title,
      message: `${message}`,
      type: "info",
    });
  }
}

export default NotificationService;
